import t3d from './Brfv4_three'

export default class {
  constructor() {
    this.imageDataCtx  = null
    this.brfv4         = null
    this.brfManager    = null
    this.resolution    = null
    this.stream = null
    this.timeoutId     = -1
    this.t3d = t3d
    this.canRender = true
    this.initialised = false
  }

  setOnComponent(opts) {
    this.webcam        = opts.webcam
    this.imageData     = opts.imageData
    this.canvas3d     = opts.canvas3d
    this.onReady = opts.onReady
    this.setFound = opts.setFound
    this.lunchwebCam()
  }

  loadWasm() {
    this.brfv4 = { locateFile: () => '/dist/brfv4/brf_wasm/BRFv4_JS_TK210219_v4.2.0_trial.wasm' }
    initializeBRF(this.brfv4)
  }

  play() {
    navigator.mediaDevices.getUserMedia({ video: { frameRate: 30, facingMode: 'user' } }).then(stream => {
			this.canRender = true
			this.webcam.srcObject = stream
			this.webcam.play()
    })
  }

  pause() {
		_.each(this.stream.getTracks(), track => track.stop())
    this.canRender = false
    this.webcam.pause()
  }

  lunchwebCam() {
    navigator.mediaDevices.getUserMedia({ video: { frameRate: 30 } }).then(stream => {
      this.stream = stream
      this.webcam.srcObject = stream
			this.webcam.pause()
			this.webcam.onloadedmetadata = () => this.onloadedmetadata()
    })
  }

  onloadedmetadata() {
    if(this.initialised) return
    this.initialised = true
    this.imageData.width = this.webcam.videoWidth
    this.imageData.height = this.webcam.videoHeight
    this.imageDataCtx = this.imageData.getContext("2d")

    this.t3d.setup(this.canvas3d, this.webcam.videoWidth, this.webcam.videoHeight)

    this.onResize()

    const intID = setInterval(() => {
      if(this.brfv4.sdkReady) {
        clearInterval(intID)
        this.init()
      }
    }, 10)
  }

  init() {
    this.resolution = new this.brfv4.Rectangle(0, 0, this.imageData.width, this.imageData.height)
    this.brfManager = new this.brfv4.BRFManager()
    this.brfManager.init(this.resolution, this.resolution, "com.tastenkunst.brfv4.js.examples.minimal.webcam")
    this.brfManager.setNumFacesToTrack(1)
    this.onReady()
    this.trackFaces()
    this.webcam.play()
  }

  trackFaces() {
    if(this.canRender) {
      this.imageDataCtx.setTransform(-1.0, 0, 0, 1, this.resolution.width, 0)
      this.imageDataCtx.drawImage(this.webcam, 0, 0, this.resolution.width, this.resolution.height)
      this.imageDataCtx.setTransform( 1.0, 0, 0, 1, 0, 0)
      this.brfManager.update(this.imageDataCtx.getImageData(0, 0, this.resolution.width, this.resolution.height).data)
      this.handleTrackingResults(this.brfv4, this.brfManager.getFaces(), this.imageDataCtx)
    }
    if(this.timeoutId >= 0) clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => this.trackFaces(), (1000 / 30))
  }


  handleTrackingResults(brfv4, faces, imageDataCtx) {
    for(var i = 0; i < faces.length; i++) {
      var face = faces[i]
      if(face.state === brfv4.BRFState.FACE_TRACKING_START || face.state === brfv4.BRFState.FACE_TRACKING) {
        this.setFound(true)
        // for(var k = 0; k < face.vertices.length; k += 2) {
        //   imageDataCtx.strokeStyle = "#0000ff"
        //   imageDataCtx.fillStyle = "white"
        //   if(k == 60)
        //     imageDataCtx.strokeStyle = "#ff0000"
        //   if(k == 27)
        //     imageDataCtx.strokeStyle = "#ff0000"
        //   imageDataCtx.fillText(k, face.vertices[k], face.vertices[k + 1])
        //   imageDataCtx.beginPath()
        //   imageDataCtx.arc(face.vertices[k], face.vertices[k + 1], 2, 0, 2 * Math.PI)
        //   imageDataCtx.stroke()
        // }
        this.t3d.update(face)
      } else {
        this.setFound(false)
      }
    }
  }

  onResize () {
    var imageData = this.imageData
    var data3d = this.canvas3d
    var ww = window.innerWidth
    var wh = window.innerHeight
    var s = wh / imageData.height
    if(imageData.width * s < ww)
      s = ww / imageData.width
    var iw = imageData.width * s
    var ih = imageData.height * s
    var ix = (ww - iw) * 0.5
    var iy = (wh - ih) * 0.5
    imageData.style.transformOrigin = "0% 0%"
    imageData.style.transform = "matrix("+s+", 0, 0, "+s+", "+ix+", "+iy+")"
    data3d.style.transformOrigin = "0% 0%"
    data3d.style.transform = "matrix("+s+", 0, 0, "+s+", "+ix+", "+iy+")"
  }

}